<script setup lang="ts">
import { DashboardEmail } from '@apparatix/schemas/DashboardEmails';

type Props = {
  type: keyof Omit<DashboardEmail['participants'], 'reply_to'>,
};

const props = defineProps<Props>();
</script>
<template>
  <div class="flex py-1 px-1.5 rounded-sm bg-[var(--p-button-secondary-background)]">
    <span class="leading-none font-light text-xs text-[var(--p-text-muted-color)]" :class="[props.type === 'to' || props.type === 'from' ? 'capitalize' : 'uppercase']">{{ props.type }}</span>
  </div>
</template>
